import { Injectable } from '@angular/core';
import { get, post, put, patch, del } from 'aws-amplify/api';
import { LoggingService } from './logging.service';

@Injectable({
  providedIn: 'root',
})
export class AmplifyApiService {
  constructor(private readonly logger: LoggingService) {}
  public async get(
    apiName: string,
    path: string,
    options?: {
      [key: string]: any;
    },
  ): Promise<any> {
    try {
      if (
        options?.headers &&
        options['headers']['X-Amz-Invocation-Type'] &&
        options['headers']['X-Amz-Invocation-Type'] === 'Event'
      ) {
        return get({ apiName, path, options }).response;
      }

      return (await get({ apiName, path, options }).response).body.json();
    } catch (error) {
      this.logger.error(error, false);
      throw error;
    }
  }

  public async post(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    const { response } = post({ apiName, path, options });
    try {
      const result = await response;
      const body = await result.body.text();
      if (body) {
        try {
          return JSON.parse(body);
        } catch (error) {
          return body;
        }
      }
    } catch (error) {
      this.logger.error(error, false);
      throw error;
    }
  }

  public async put(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    const { response } = put({ apiName, path, options });
    try {
      const result = await response;
      const body = await result.body.text();
      if (body) {
        try {
          return JSON.parse(body);
        } catch (error) {
          return body;
        }
      }
    } catch (error) {
      this.logger.error(error, false);
      throw error;
    }
  }

  public async patch(
    apiName: string,
    path: string,
    options: {
      [key: string]: any;
    },
  ): Promise<any> {
    const { response } = patch({ apiName, path, options });
    try {
      const result = await response;
      const body = await result.body.text();
      if (body) {
        try {
          return JSON.parse(body);
        } catch (error) {
          return body;
        }
      }
    } catch (error) {
      this.logger.error(error, false);
      throw error;
    }
  }

  public async del(
    apiName: string,
    path: string,
    options?: {
      [key: string]: any;
    },
  ): Promise<any> {
    try {
      return await del({ apiName, path, options }).response;
    } catch (error) {
      this.logger.error(error, false);
      throw error;
    }
  }
}
